import {Component, EventEmitter, Input, OnInit, Output, Renderer2} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { forEach } from 'jszip';
import 'rxjs/add/operator/take';
import { BundleQuestionModel, BundleQuestionModelCore, MasterSummaryQuestionModel } from '../../../../../models/survey/survey.model';
import { SurveyService } from '../../../surveys.service';

@Component({
  selector: 'bundle-popup',
  templateUrl: './bundle-popup.component.html',
  styleUrls: ['./bundle-popup.component.less']
})
export class BundlePopupComponent implements OnInit {

  @Output('close') close = new EventEmitter();
  @Input() surveyId: number;
  @Input() questions: BundleQuestionModelCore[] = [];
  @Input() model: BundleQuestionModel;
  @Output() reloadData = new EventEmitter();
  bundleForm: FormGroup;
  showLoader = false;
  nameMaxLength = 255;
  
  constructor(private fb: FormBuilder, private surveyService: SurveyService,  private renderer: Renderer2) {
    this.bundleForm = this.fb.group({
        'bundleName': [null, [Validators.required, Validators.maxLength(this.nameMaxLength)]],
        'scaleMax': [10, [Validators.pattern('^[0-9]*$'), Validators.required, Validators.min(1), Validators.max(999)]],
    });
  }

  ngOnInit() {
    if (this.model.id !== undefined) {
        this.updateForm();
    }
    this.surveyService.getSurveyQuestionForBundleQuestion(this.surveyId, this.model.id).subscribe(res => {
        this.questions = res;
        if (this.model.questions != undefined) {
            this.questions.forEach(element => {
                element.checked = this.model.questions.find(m => m.id == element.id) !== undefined;
            });
        }
    }, err => {

    });
  }

  onClose() {
    this.close.next();
    this.renderer.removeClass(document.body, 'modal-open');
  }

  onSave() {

    if (this.bundleForm.valid) {
        this.showLoader = true;
        this.renderer.removeClass(document.body, 'modal-open');
        const bundleQuestion = new BundleQuestionModel();
        bundleQuestion.bundleName = this.bundleForm.get(['bundleName']).value;
        bundleQuestion.scaleMax = this.bundleForm.get(['scaleMax']).value;
        bundleQuestion.questions = this.questions;
        bundleQuestion.surveyId = this.surveyId;
        bundleQuestion.id = this.model.id;
        this.surveyService.updateBundleQuestion(bundleQuestion).subscribe(res => {
            this.onClose();
            this.reloadData.emit();
        }, err => {
    
        });
    }
  }

  onKeyupBundleName(e: any) {
    if (e.target.value !== '') {
        this.surveyService.getBundleByName(this.surveyId, e.target.value, this.model.id).subscribe(res => {
            if (res !== null) {
                this.bundleForm.controls['bundleName'].setErrors({'existing': true})
            }
        }, err => {
        });
    }
  }

  updateForm() {
    this.bundleForm.controls['bundleName'].setValue(this.model.bundleName);
    this.bundleForm.controls['scaleMax'].setValue(this.model.scaleMax);
  }

  isQuestionChecked(): boolean {
    if (this.questions !== undefined) {
        return this.questions.find(f => f.checked == true) !== undefined;
    }
    return false;
  }
  
  ngOnDestroy() {
    this.renderer.removeClass(document.body, 'modal-open');
  }
}



// WEBPACK FOOTER //
// ./src/app/routes/surveys/new-survey/bundle-tab/bundle-popup/bundle-popup.component.ts